import { Request } from "@xt/xtbase";
const { XtAxios4 } = Request;

const URL = "/sapi/v4/fund/";

//划转
export function post_balanceTransfer(config?) {
  return XtAxios4.post(URL + `balance/transfer`, null, config);
}
